import script from "./AccountCardsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountCardsSection.vue?vue&type=script&setup=true&lang=ts"

import "./AccountCardsSection.vue?vue&type=style&index=0&id=72e6e694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e6e694"]])

export default __exports__